import styled from 'styled-components';

export const AutocompleteText = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  max-width: calc(100% - 24px);
  overflow: hidden;
  font-family: inherit;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  line-height: 1.5;
  white-space: pre;
  z-index: 1;
  color: ${({ theme }) => theme.colorPalette.grey.grey7};
  font-style: italic;
`;

export const InputRowContainer = styled.div<{ isEmbedded: boolean }>`
  display: flex;
  flex-shrink: 0;
  border: ${({ theme, isEmbedded }) => (isEmbedded ? '1px solid ' + theme.colorPalette.grey.grey5 : 'none')};
  border-top: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
  margin-top: auto;
  position: relative;
  overflow: visible;
  padding: 12px;
`;

export const StyledInput = styled.input`
  flex: 1;
  padding: 12px;
  border: none;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  background: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  color: ${({ theme }) => theme.colorPalette.black};
  width: 100%;
  height: 100%;

  :focus {
    outline: none;
  }
`;
